import React from 'react';
import { Product } from '../../../types';
import { ProductCard } from '../atoms';
import './ProductGrid.css';

export interface ProductGridProps {
  products: Product[];
  onProductClick?: (product: Product) => void;
  onEdit?: (product: Product) => void;
  onDuplicate?: (product: Product) => void;
  onDelete?: (product: Product) => void;
  loading?: boolean;
}

const ProductGrid: React.FC<ProductGridProps> = ({ 
  products, 
  onProductClick,
  onEdit,
  onDuplicate,
  onDelete,
  loading = false
}) => {
  console.log("ProductGrid rendering with:", { products, loading });
  
  return (
    <div className="product-grid-container">
      {loading ? (
        <div className="product-grid-loading">Loading products...</div>
      ) : products.length === 0 ? (
        <div className="product-grid-empty">No products found</div>
      ) : (
        <div className="product-grid">
          {products.map(product => (
            <div key={product.id} className="product-grid-item">
              <ProductCard 
                product={product} 
                onClick={onProductClick}
                onEdit={onEdit}
                onDuplicate={onDuplicate}
                onDelete={onDelete}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductGrid;
